import React, { useEffect, useState, useRef, Children } from 'react'
import TestTag from '../../component/common/testclinic.tag'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Redirect,
  Link,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import {
  Row,
  Col,
  Button,
  Breadcrumb,
  Spin,
  Collapse,
  Drawer,
  Typography,
} from 'antd'
import '../../css/patient.scss'
import util from '../../util/util'
import { getPatient, getPatientRomTests } from '../../store/action/patient.action'
import { getPatientNotesCount } from '../../store/action/patientnotes.action'
import { Patient } from '../../component'
import _ from 'lodash'
import { useWindowsSize } from '../../component'
import PatientGraphs from '../../component/patient/forms/patientgraphs'
import TracPatchExercises from '../../component/patient/forms/tracpatch.exercises'
import PatientNotes from '../../component/patient/patient.notes'
import WoundImages from '../../component/patient/wound.images'
import serviceInterface from '../../services/service.interface'
import { MenuOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import {
  CaretLeftFilled,
  CloseOutlined,
  DownSquareFilled,
  CloseCircleFilled,
} from '@ant-design/icons'
import DrawerWrapper from 'antd/lib/drawer'
const { Text } = Typography

var form = undefined
var { Forms, Calendar, Buttons, Events, Info } = Patient

const PatientView = (props) => {
  var history = useHistory()
  var location = useLocation()
  var params = useParams()
  const ref = useRef(null)
  const size = useWindowsSize()
  const { Panel } = Collapse
  const [currentdate, setDate] = useState(new Date())
  const [dayView, setDayView] = useState(false)
  const [days, setDays] = useState(1)
  const [spinning, setSpinning] = useState(true)
  const [open, setOpen] = useState(false)
  const [activeKey, setActiveKey] = useState(['3']) // Default to Charts
  const [woundImagesCount, setWoundImagesCount] = useState(0)

  // Lightweight count for the "Wound Images (N)" header — a cheap countDocuments
  // on the server, so we don't fetch the full image list (with resolved
  // thumbnails) just to show a number. The full section stays lazy and only
  // fetches its images when the panel is expanded.
  useEffect(() => {
    const pid = props.patient && props.patient._id
    // Knee-surgery only — the Wound Images section is gated on isKneeSurgery(),
    // so don't even fetch the count for non-knee (e.g. hip) patients.
    if (!pid || !isKneeSurgery()) {
      setWoundImagesCount(0)
      return
    }
    serviceInterface
      .PatientService()
      .getWoundImagesCount(pid)
      .then((count) => setWoundImagesCount(typeof count === 'number' ? count : 0))
      .catch(() => setWoundImagesCount(0))
  }, [props.patient && props.patient._id])
  const containerRef = useRef(null)

  useEffect(() => {
    props.fetchPatient(params.id).then((res) => {
      if (!res) history.push('/patient')
    })
  }, [])

  // Update active key when patient data loads
  useEffect(() => {
    if (props.patient?._id && props.customer?.surgerytypes) {
      setActiveKey(getDefaultActiveKey())
    }
  }, [props.patient?._id, props.customer?.surgerytypes])

  useEffect(() => {
    setSpinning(props.isLoading)
  }, [props.isLoading])

  // Load patient notes count when patient is available
  useEffect(() => {
    if (props.patient?._id) {
      props.getPatientNotesCount(props.patient._id)
    }
  }, [props.patient?._id])

  // Load TracPatch Progress-Test (ROM) records so the Activity Calendar & Day
  // View can mark the TracPatch measurement done on days a Progress Test was
  // completed (it lives outside the device timesheet).
  useEffect(() => {
    if (props.patient?._id) {
      props.getPatientRomTests(props.patient._id)
    }
  }, [props.patient?._id])

  useEffect(() => {
    var width = ref.current ? ref.current.offsetWidth : 0
    setDays(Math.floor(width / 310))
  }, [ref.current, size.width, size.height])

  const renderGraph = () => {
    return <PatientGraphs isLoading={(e) => setSpinning(e)} />
  }

  const renderPatientNotes = () => {
    return <PatientNotes patient={props.patient} />
  }

  const renderCalender = () => {
    return (
      <>
        <div ref={ref}>
          <Row>
            <Calendar
              date={currentdate}
              setDate={setDate}
              dayView={dayView}
              setDayView={setDayView}
              days={days}
            />
          </Row>
          <Row>&nbsp;</Row>
          {!dayView && (
            <Collapse defaultActiveKey={''}>
              <Panel header='Reminders' key='1'>
                <Row hidden={dayView}>
                  <Events date={currentdate} />
                </Row>
              </Panel>
            </Collapse>
          )}
        </div>
      </>
    )
  }

  // Helper function to check if patient's surgery type is surgical
  const isPatientSurgical = () => {
    if (!props.customer?.surgerytypes || !props.patient?.surgery?.type) {
      return true // Default to true if no data
    }

    const matchingSurgeryType = props.customer.surgerytypes.find(
      st => st.name?.toLowerCase() === props.patient.surgery.type.toLowerCase()
    )

    return matchingSurgeryType ? matchingSurgeryType.issurgical : true
  }

  // Wound images are only relevant for knee surgery patients
  const isKneeSurgery = () => {
    return !!(
      props.patient &&
      props.patient.surgery &&
      props.patient.surgery.type &&
      props.patient.surgery.type.toLowerCase() === 'knee'
    )
  }

  // Determine which panel should be open by default
  const getDefaultActiveKey = () => {
    // If patient is non-surgical, open Activity Calendar (key='2')
    // Otherwise, open Charts (key='3')
    return isPatientSurgical() ? ['3'] : ['2']
  }

  // console.log('patte',history.location)

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Spin
      spinning={
        props?.patient.firstname == undefined || spinning ? true : false
      }
    >
      <div
        style={{
          height: `100%`,
          width: '100%',
          position: 'relative',
          // To hide the overflow of the drawer
          overflowX: 'hidden',
          minWidth: '900px',
        }}
      >
        <Col className={'patientViewContainer'} ref={containerRef}>
          {/* Custom Drawer */}
          <div className={`custom-drawer ${open ? 'open' : ''}`}>
            <div className='drawer-content'>
              <Row justify={'space-between'} align={'top'}>
                <div className='actionRow'>
                  <Text
                    style={{
                      letterSpacing: '1.5px',
                      fontSize: '20px',
                      textShadow: '1px 1px 2px #000000',
                      paddingLeft: '30px',
                    }}
                  >
                    ACTION
                  </Text>
                </div>
                <Button
                  icon={<CloseOutlined />}
                  type='text'
                  onClick={() => setOpen(false)}
                ></Button>
              </Row>
              <Row justify={'center'} align={'bottom'}>
                <Buttons dayView={dayView} date={currentdate} />
              </Row>
            </div>
          </div>
          {open && (
            <div className='backdrop' onClick={() => setOpen(false)}></div>
          )}
          <Row className={'actionRow'}>
            <Col flex={'300px'}>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to='/patient'>Patients</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  {_.upperFirst(props?.patient?.firstname) +
                    ' ' +
                    _.upperFirst(props?.patient?.lastname)}
                  <TestTag isTest={props?.patient?.istestpatient} />
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col style={{ alignSelf: 'center' }} flex={'auto'}>
              <Row justify={'end'} align={'bottom'}>
                <Button
                  className='notification-btn'
                  style={{
                    boxShadow:
                      '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
                  }}
                  icon={<DownSquareFilled />}
                  onClick={() => setOpen(true)}
                  disabled={
                    props.isLoading || !props.isActive || !props.patient?.active
                  }
                >
                  Action
                </Button>
              </Row>
            </Col>
            <Col>&nbsp;&nbsp;&nbsp;</Col>
            <Row justify={'end'} align={'bottom'}>
              <Link
                to={
                  history.location?.state?.back
                    ? history.location?.state?.back
                    : '/patient'
                }
              >
                <Button
                  style={{
                    boxShadow:
                      '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
                  }}
                  className='notification-btn'
                  icon={<CaretLeftFilled />}
                >
                  Back
                </Button>
              </Link>
            </Row>
          </Row>
          <Row>&nbsp;</Row>
          <Row gutter={20} style={{ flexFlow: 'nowrap' }}>
            <Col style={{ maxWidth: '315px' }} flex={'20%'}>
              <Row>
                <Info />
              </Row>
              <Row>&nbsp;</Row>
              {/* <Row>
                            <Forms modal={true}/>
                        </Row> */}
            </Col>
            <Col flex={'80%'}>
              <Collapse activeKey={activeKey} onChange={setActiveKey}>
                <Panel
                  header={
                    <span
                      style={{
                        color: '#1890ff',
                        textDecoration: 'underline',
                        fontSize: '1.1rem',
                        fontweight: 600,
                      }}
                    >
                      Patient Notes ({props.patientNotesTotal || 0})
                    </span>
                  }
                  key='1'
                >
                  {renderPatientNotes()}
                </Panel>
                {isKneeSurgery() && (
                  <Panel
                    header={
                      <span
                        style={{
                          color: '#1890ff',
                          textDecoration: 'underline',
                          fontSize: '1.1rem',
                          fontweight: 600,
                        }}
                      >
                        Wound Images ({woundImagesCount})
                      </span>
                    }
                    key='1.5'
                  >
                    <WoundImages patient={props.patient} />
                  </Panel>
                )}
                <Panel
                  header={
                    <span
                      style={{
                        color: '#1890ff',
                        textDecoration: 'underline',
                        fontSize: '1.1rem',
                        fontweight: 600,
                      }}
                    >
                      Activity Calendar & Reminders
                    </span>
                  }
                  key='2'
                >
                  {renderCalender()}
                </Panel>
                {isPatientSurgical() && (
                  <Panel
                    header={
                      <span
                        style={{
                          color: '#1890ff',
                          textDecoration: 'underline',
                          fontSize: '1.1rem',
                          fontweight: 600,
                        }}
                      >
                        TracPatch Exercises
                      </span>
                    }
                    key='2.5'
                  >
                    <TracPatchExercises />
                  </Panel>
                )}
                {isPatientSurgical() && (
                  <Panel
                    header={
                      <span
                        style={{
                          minWidth: '300px',
                          color: '#1890ff',
                          textDecoration: 'underline',
                          fontSize: '1.1rem',
                          fontweight: 600,
                        }}
                      >
                        Charts
                      </span>
                    }
                    key='3'
                  >
                    {renderGraph()}
                  </Panel>
                )}
              </Collapse>
            </Col>

            {/* <Col flex={"auto"}>
                        <div ref={ref} >
                            <Row>
                                <Calendar 
                                    date={currentdate} 
                                    setDate={setDate}
                                    dayView={dayView}
                                    setDayView={setDayView}
                                    days={days}
                                />
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row hidden={dayView}>
                                <Events date={currentdate} />
                            </Row>
                        </div>
                    </Col> */}
          </Row>
        </Col>
      </div>
    </Spin>
  )
}

PatientView.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
  fetchPatient: PropTypes.func.isRequired,
  getPatientNotesCount: PropTypes.func.isRequired,
  patientNotesTotal: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.patient.isLoading,
    customer: state.profile.customer,
    patient: state.patient.patient,
    isActive: state.patient.isActive,
    patientNotesTotal: state.patientnotes.total,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (id) => dispatch(getPatient(id)),
    getPatientRomTests: (id) => dispatch(getPatientRomTests(id)),
    getPatientNotesCount: (patientId) =>
      dispatch(getPatientNotesCount(patientId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientView)
